import React from 'react';
import ReactDOM from 'react-dom';
import * as Components from './components/commonComponents';
import ReactDOMServer from 'react-dom/server';
import { frontendLogger } from '../../Cms/Static/Js/typescript/FrontendLogger';
import 'whatwg-fetch';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';

const hasServerComponentRegistry = Boolean(global['VGR']?.Components?.FtvWebBookingWizardPage);

if (!hasServerComponentRegistry) {
	global['React'] = React;
	global['ReactDOM'] = ReactDOM;
	global['ReactDOMServer'] = ReactDOMServer;
	global['VGR'] = global['VGR'] || {};
	global['VGR'].Components = {
		...(global['VGR'].Components || {}),
		...Components,
	};
}

if (typeof globalThis !== 'undefined') {
	const runtime = globalThis as typeof globalThis & {
		VgrFrontend?: {
			logger?: typeof frontendLogger;
		};
		window?: Window & typeof globalThis & {
			VgrFrontend?: {
				logger?: typeof frontendLogger;
			};
		};
	};

	runtime.VgrFrontend = runtime.VgrFrontend || {};
	runtime.VgrFrontend.logger = frontendLogger;

	if (typeof runtime.window !== 'undefined') {
		runtime.window.VgrFrontend = runtime.VgrFrontend;
	}
}

dayjs.locale('sv');